import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Gallery from "../pages/gallery/page";
import Contact from "../pages/contact/page";
import SubmitReview from "../pages/submit-review/page";
import ManageReviews from "../pages/manage-reviews/page";
import EventGallery from "../pages/event-gallery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/event-gallery",
    element: <EventGallery />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/submit-review",
    element: <SubmitReview />,
  },
  {
    path: "/manage-reviews",
    element: <ManageReviews />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
